import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { serverErrorMessage } from "@core/helpers";
import { HelperFunctionsService } from "@core/services/helper-functions.service";
import { Reward } from "@core/models/reward";
import { QuizService } from "@core/services/quiz.service";
import { Subject, takeUntil } from "rxjs";
import { QuizModuleService } from "../../quiz-module.service";
import { Router } from "@angular/router";

@Component({
  standalone: false,
  selector: "app-gifts",
  templateUrl: "./gifts.component.html",
  styleUrls: ["./gifts.component.scss"],
})
export class GiftsComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject();
  rewards: Reward[];
  hasNewGift: boolean;
  private _helpers = inject(HelperFunctionsService);

  constructor(private quizService: QuizModuleService, private router: Router) {}

  openGiftsPage(): void {
    this.router.navigate(["quiz/gifts"]);
  }

  postUserGifts(userId: number): void {
    this.quizService
      .postUserGifts(userId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          console.log(res);
        },
        (err) => {
          this._helpers.showWarningToastr(
            serverErrorMessage(err, "Couldn't claim this gift. Please try again.")
          );
        }
      );
  }

  getUserGifts(): void {
    this.quizService
      .getUserGifts()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          if(!res.length) document.getElementById('gift-icon').classList.add('hide-gift-icon');
          this.rewards = res;
          this.hasNewGift = this.rewards.some(
            (gift) => gift.new === true
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  ngOnInit(): void {
    this.getUserGifts();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }
}
